import React from 'react'
import PropTypes from 'prop-types'
import {withRouter} from'react-router-dom'
import {useSelector,useDispatch} from "react-redux"
import {submit} from "redux-form";
import {
    ADD_DOMAIN_PAGE,
    ADD_PRODUCT_PAGE,
    EDIT_DOMAIN_PAGE,
    EDIT_PRODUCT_PAGE
} from "../../../../utilities/function/common"

import {
    getCID,
    getDataFromURL,
    getPageByURL
} from "../../../../utilities/function/urlparams"

import {
    isLastStep,
    getFilteredConfigurationList
} from "../../../../utilities/function/configuration"


import {DOMAIN_TYPE} from "../../../../utilities/function/servicetype";
import SolidButton from "../../button/solidbutton";

const CONTINUE = 'Continue'
const UPDATE = 'Update'
const GO_TO_CART ='Proceed to Cart'


// Shared 'Continue' Button: This button is shared between the main window and right pane (pink)
// This Button is currently only used with the domain checkout.
let SelectButtonDomain = (props) => {
    const dispatch = useDispatch()
    const {configurations,SelectDomainConfigForm} = useSelector(state=>({
        configurations: state.app.configurations,
        SelectDomainConfigForm: state.form.SelectDomainConfigForm
    }))
    const {className,location,history,isDarked} = props
    const urlParams = getDataFromURL(location.search)
    const pageType = getPageByURL(location.search)
    const domainList =  getFilteredConfigurationList(DOMAIN_TYPE,configurations,false)
    const DISABLED_BACKGROUND = isDarked? "of-select-button--disabled text-background-4-100 ": "of-select-button--disabled lines-background-1-100 "
    const DISABLED_TEXT = "text-font-1-60 "
    //domain page one
    const renderAddDomainPageOneButton = () => {
        const onClickCallback = ()=>{
            if(urlParams){
                const {a,domain,query,promo} = urlParams
                if(domainList && domainList.length && Array.isArray(domainList)){
                    history.push(`${window.location.pathname}?a=${a}&domain=${domain}&query=${query}&config=true${promo?`&promo=${promo}`:''}`)
                }
            }
        }
        const isInvalid = ()=>!(domainList && domainList.length && Array.isArray(domainList))
        return (
            <SolidButton onClick={onClickCallback}
                         className={`${isInvalid()?DISABLED_BACKGROUND+DISABLED_TEXT:''}of-select-button${className?' '+className:''}`}>Continue</SolidButton>
        )
    }

    //domain page two
    const renderDomainPageTwoButton = () => {
        const getProductPageText = (val) => {
            let text = val
            const cid = getCID(getDataFromURL(location.search))
            if((configurations[cid] && isLastStep(configurations[cid].breadcrumbs,configurations[cid].step))){
                if(pageType=== ADD_PRODUCT_PAGE){
                    text = GO_TO_CART
                }else{
                    text = UPDATE
                }
            }
            return text
        }
        let text = CONTINUE
        switch (pageType){
            case EDIT_DOMAIN_PAGE:
                text = UPDATE
                break
            case ADD_DOMAIN_PAGE:
                text = GO_TO_CART
                break
            case ADD_PRODUCT_PAGE:
            case EDIT_PRODUCT_PAGE:
                text = getProductPageText(text)
                break
            default:
                break
        }

        const onClickCallback = (e) => {
            e.preventDefault()
            dispatch(submit('SelectDomainConfigForm'))
        }

        const isInvalid = () =>!!(SelectDomainConfigForm && SelectDomainConfigForm.syncErrors)
        return (
            <SolidButton
                className={`${isInvalid()?DISABLED_BACKGROUND+DISABLED_TEXT:''}of-select-button of-select-domain-config-form__button${className?' '+className:''}`}
                onClick={onClickCallback}
            >{text}</SolidButton>
        )
    }

    //domain page one and two
    const renderAddDomainPageButton = () => {
        const {config} = urlParams
        if(config){
            return renderDomainPageTwoButton()
        }
        return renderAddDomainPageOneButton()
    }

    //other page just show page domain page two button
    switch (pageType){
        case ADD_DOMAIN_PAGE:
            return renderAddDomainPageButton()
        default:
            return renderDomainPageTwoButton()
    }
}



SelectButtonDomain = withRouter(SelectButtonDomain)

SelectButtonDomain.propTypes = {
    className: PropTypes.string,
    location: PropTypes.object,
    history: PropTypes.object,
    isDarked: PropTypes.bool
}

export default SelectButtonDomain